import FloatingLayer from './FloatingLayer';
import MainFloatingLayer from './MainFloatingLayer';
import ImageLayer from './ImageLayer';
import MovieLayer from './MovieLayer';
import ToastLayer from './ToastLayer';
import MainToastLayer from './MainToastLayer';
import TopLayer from './TopLayer';
import {ICommonbannerConfig, ncBannerI18n, ncBannerOptions} from '../../interface/ICommonbanner';

/**
 * @category Commonbanner
 * @description
 * RWD 공통 배너 5종
 * 상단 띠배너
 * 이미지 배너
 * 영상 배너
 * 플로팅 배너
 * 토스트 배너
 */
class NcBanner {
    data: ncBannerOptions;
    url:string;
    constructor(_config: ICommonbannerConfig) {
        this.data = _config.ncBanner;       
        this.url = _config.wstatic;
        this.init();
    }
    
    init(){
        // 현재 페이지가 메인인지 확인 body 태그에  class명으로 체크
        // page-index : 리니지2
        // page-main : 블소, 아이, 리니지, 리니지2M
        // main : 리니지M,H2
        // 미정 : 트릭스터M
        const isMain = document.body.classList.contains('page-main') || document.body.classList.contains('page-index') || document.body.classList.contains('main');
        const isLauncher = document.body.classList.contains('launcher');

        // 메인페이지 이면 상단띠배너, 영상배너, 이미지배너, 메인 플로팅배너, 메인 토스트배너 노출
        // 메인페이지가 아니면(서브페이지) 서브 플로팅배너, 서브 토스트배너 노출
        new MovieLayer( isMain, isLauncher, this.data);
        new ImageLayer( isMain, isLauncher, this.data);
        new TopLayer( isMain, isLauncher, this.data);        

        new ToastLayer( isMain, isLauncher, this.data );
        new MainToastLayer( isMain, isLauncher, this.data );
        new FloatingLayer( isMain, isLauncher, this.data );
        new MainFloatingLayer( isMain, isLauncher, this.data );        

     }  
     
}

export default NcBanner;
